import React from 'react';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type NotFoundErrorPageType from '@atlassian/jira-error-pages/src/ui/not-found-error-page/NotFoundErrorPage.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';

export const LazyExplicitFieldsProjectListPromise = lazyForPaint<typeof NotFoundErrorPageType>(
	() =>
		import(
			/* webpackChunkName: "async-error-pages-not-found", jiraSpaEntry: "async-error-pages-not-found" */ '@atlassian/jira-spa-apps-error-pages-not-found'
		),
);

// This route is in the middle of a feature flag cleanup. I will remove the whole file in the next PR.
export const LazyExplicitFieldsProjectListPage = () => (
	<LazyPage
		Page={LazyExplicitFieldsProjectListPromise}
		pageId="errors-404"
		shouldShowSpinner={false}
	/>
);
